<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M36 24L40 24M36 24C36 21.7909 34.2091 20 32 20C29.7909 20 28 21.7909 28 24M36 24C36 26.2091 34.2091 28 32 28C29.7909 28 28 26.2091 28 24M12 12C12 14.2091 13.7909 16 16 16C18.2091 16 20 14.2091 20 12M12 12C12 9.79086 13.7909 8 16 8C18.2091 8 20 9.79086 20 12M12 12L8 12M20 12L40 12M28 24L8 24M12 36C12 38.2091 13.7909 40 16 40C18.2091 40 20 38.2091 20 36M12 36C12 33.7909 13.7909 32 16 32C18.2091 32 20 33.7909 20 36M12 36L8 36M20 36L40 36"
    stroke="currentColor"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
